import { render } from "./SubCategoryView.vue?vue&type=template&id=0ddb5d12"
import script from "./SubCategoryView.vue?vue&type=script&lang=js"
export * from "./SubCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__